export const DAYS_FROM_DEPARTURE = 1;
export const MAXIMUM_STAY = 28;
